import { useMemo, useCallback } from 'react';
import { useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { scriptsRequestIdState } from './atoms.js';
import { scriptsSelector } from './selectors.js';

function useScripts() {
    var scriptsSelectorLoadable = useRecoilValueLoadable(scriptsSelector);
    var setScriptsRequestId = useSetRecoilState(scriptsRequestIdState);
    var memoScripts = useMemo(function () {
        if (scriptsSelectorLoadable && scriptsSelectorLoadable.state === "hasValue") {
            return scriptsSelectorLoadable.contents;
        }
        else if (scriptsSelectorLoadable && scriptsSelectorLoadable.state === "hasError") {
            console.error("[useScript] error while loading script", scriptsSelectorLoadable.contents);
        }
        return null;
    }, [scriptsSelectorLoadable]);
    var refreshScripts = useCallback(function () {
        setScriptsRequestId(function (requestId) { return requestId + 1; });
    }, [setScriptsRequestId]);
    return {
        loading: scriptsSelectorLoadable.state === "loading",
        error: (scriptsSelectorLoadable.state === "hasError" && scriptsSelectorLoadable.contents) || null,
        scripts: memoScripts,
        refreshScripts: refreshScripts
    };
}

export { useScripts };
//# sourceMappingURL=hooks.js.map
